const options = {
	rootClass: 'zp-word-scroller',
	initType: 1
};

LoaderFactory(options, (function (w, d, $, undefined) {

	const _w = $(w);
	const _d = $(d);

	class WordScroller {

		constructor(root) {
			this.root = root;
			this.init();
		}

		init() {
			this.translateY = 0;
			this.animating = false;

			this.elementScale = 1;
			this.scaleAnimating = false;

			this.lineContainer = this.root.find('.line-container');

			const stepCount = this.root.find('.data-atts').data('step-count');
			const wordCount = this.root.find('.data-atts').data('word-count');
			this.scrollLimit = ((wordCount - stepCount) * this.root.find('.step').innerHeight()) + 2;

			this.offsetStartPercent = this.root.find('.data-atts').data('offset-start');
			this.offsetEndPercent = this.root.find('.data-atts').data('offset-end');

			_w.on('scroll.word-scroller-animate', this.onScroll.bind(this));
			_w.on('resize.word-scroller-animate', this.onScroll.bind(this));
			_w.on('resize.word-scroller-scale', this.onResizeScale.bind(this));
			_w.trigger('scroll.word-scroller-animate');
			_w.trigger('resize.word-scroller-scale');
		}

		onScroll() {
			const windowScrollTop = _w.scrollTop();
			const windowHeight = _w.height();

			const elementScrollTop = this.root.offset().top - windowScrollTop;
			const offsetStart = Math.floor(windowHeight * this.offsetStartPercent / 100);
			const offsetEnd = Math.floor(windowHeight * this.offsetEndPercent / 100);

			if(elementScrollTop >= offsetStart) {
				this.translateY = 0;
			} else if(elementScrollTop <= offsetEnd) {
				this.translateY = -this.scrollLimit;
			} else {
				this.translateY = (((offsetStart) - elementScrollTop) * -1) / (offsetStart - offsetEnd) * (this.scrollLimit);
			}

			this.requestAnimation();
		}

		requestAnimation() {
			if(!this.animating) {
				requestAnimationFrame(this.draw.bind(this));
			}
			this.animating = true;
		}

		draw() {
			this.animating = false;
			const translateY = this.translateY;

			this.lineContainer.css({
				'transform':'translateY('+ translateY +'px)',
				'-webkit-transform':'translateY('+ translateY +'px)'
			});
		}

		onResizeScale() {
			const windowWidth = _w.width();
			const breakpoint = 2000;

			if(windowWidth < breakpoint) {
				this.elementScale = windowWidth / breakpoint;
			} else {
				this.elementScale = 1;
			}

			this.requestScalingAnimation();
		}

		requestScalingAnimation() {
			if(!this.scaleAnimating) {
				requestAnimationFrame(this.drawScaling.bind(this));
			}
			this.scaleAnimating = true;
		}

		drawScaling() {
			this.scaleAnimating = false;
			const elementScale = this.elementScale;
			this.root.css({
				'transform':'scale('+ elementScale +')',
				'-webkit-transform':'scale('+ elementScale +')'
			});
		}

	}

	return WordScroller;

}(window, document, jQuery)));